import { render, staticRenderFns } from "./rightMan.vue?vue&type=template&id=16131850&scoped=true&"
import script from "./rightMan.vue?vue&type=script&lang=js&"
export * from "./rightMan.vue?vue&type=script&lang=js&"
import style0 from "./rightMan.vue?vue&type=style&index=0&id=16131850&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16131850",
  null
  
)

export default component.exports